import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = "";

const shopSlice = createSlice({
  name: "shop",
  initialState,
  reducers: {
    setShop(state, action: PayloadAction<string | number>) {
      state = action.payload as string;

      return state;
    },
  },
});

const { reducer, actions } = shopSlice;
export const { setShop } = actions;
export default reducer;
